import type { DecryptedLink } from '../../store/_links/interface';
import type { DecryptedNode } from './interface';

/**
 * Converts a Drive store object to a DecryptedNode.
 */
export const decryptedLinkToNode = (link: DecryptedLink, volumeId?: string): DecryptedNode => {
    return {
        volumeId: volumeId || link.volumeId,
        nodeId: link.linkId,
        parentNodeId: link.parentLinkId,
        name: link.name,
        hash: link.hash,
        createTime: link.createTime,
        mimeType: link.mimeType,
        signatureAddress: link.signatureEmail,
        nameSignatureAddress: link.nameSignatureEmail,
        isCorruptedNode: link.corruptedLink,
        trashed: link.trashed,
        trashedByParent: link.trashedByParent,
    } satisfies DecryptedNode;
};
